<template>
    <v-navigation-drawer
        v-model="drawerModel"
        class="member_app_nav"
        clipped
        fixed
        app
        enable-resize-watcher
        mobile-breakpoint="xs"
        width="220"
    >
        <v-card flat height="100%" width="100%">

            <div style="height: 100%;" class="d-flex flex-column justify-space-between">

                <v-list width="220" dense>

                    <!-- MENU ITEMS -->
                    <v-list-item dense
                                 v-for="item in items"
                                 :key="item.id"
                                 :class="isRouteActive(item.route) ? 'arrow_box': 'menu_item'"
                                 ripple
                                 @click="itemClicked(item)">

                        <v-list-item-action class="mr-4">
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>

                        <v-list-item-content>
                            <v-list-item-title>
                                <div>
                                    <v-badge
                                        bordered
                                        :color="config.settings.actionButtonColor"
                                        inline
                                        :content="item.count"
                                        :value="item.count > 0"
                                    >
                                        <span>{{ item.name }}</span>
                                    </v-badge>

                                </div>
                            </v-list-item-title>

                        </v-list-item-content>

                        <div v-show="isRouteActive(item.route)" class="arrowBox">
                            <v-btn icon>
                                <v-icon large color="grey">mdi-menu-right</v-icon>
                            </v-btn>
                        </div>

                    </v-list-item>

                </v-list>

                <!-- LOGOUT BUTTON -->
                <v-list width="220" dense>
                    <v-list-item @click="logout" class="menu_item">

                        <v-list-item-action class="mr-4">
                            <v-icon>mdi-logout</v-icon>
                        </v-list-item-action>

                        <v-list-item-content>
                            <v-list-item-title>{{ translations.menu_item_logout }}</v-list-item-title>
                        </v-list-item-content>

                    </v-list-item>
                </v-list>
            </div>
        </v-card>

    </v-navigation-drawer>
</template>

<script>

import {mapState} from "vuex";
import colorMixin from "@/components/mixins/colorMixin.js";

const vuexModule = 'Community';

export default {

    name: "AppNavigationDrawer",

    mixins: [colorMixin],

    props: {
        value: {
            type: Boolean,
            required: true,
        },
        translations: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            mini: false,
            activeRoute: null,
            burgerCycle: ['wide', 'narrow', 'hidden'],
            burgerCycleIndex: 0,
            viewportWidth: null,
            viewportHeight: null,
            availableQuestions: 0,
            availableSurveys: 0,
        }
    },

    watch: {
        $route(to) {
            this.setActiveRoute(to.path);
        }
    },

    computed: {

        ...mapState(vuexModule, [
            'config',
            'account',
        ]),

        drawerModel: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },

        mobile() {
            if (this.viewportWidth < 600) {
                return true;
            }
        },

        items() {

            let items = [];

            let data = {
                name: this.translations.menu_item_surveys,
                route: '/app/surveys',
                icon: 'mdi-account-voice'
            }

            if (this.availableSurveys > 0) {
                data.count = this.availableSurveys;
            }

            items.push(data);

            if (this.config.dynamic_profiling_enabled) {

                let data = {
                    name: this.translations.menu_item_profile,
                    route: '/app/profile',
                    icon: 'mdi-crosshairs-question',
                };

                if (this.availableQuestions > 0) {
                    data.count = this.availableQuestions;
                }

                items.push(data);
            }

            if (this.config.rewards_enabled) items.push({
                name: this.translations.menu_item_rewards,
                route: '/app/rewards',
                icon: 'mdi-star-circle-outline'
            });

            if (this.config.redemptions_enabled) items.push({
                name: this.translations.menu_item_redemptions,
                route: '/app/redemptions',
                icon: 'mdi-history'
            });

            items.push({
                name: this.translations.menu_item_activity_history,
                route: '/app/activity',
                icon: 'mdi-order-bool-ascending-variant'
            });

            items.push({
                name: this.translations.menu_item_my_account,
                route: '/app/account',
                icon: 'mdi-account-outline'
            });

            if (this.account && this.account.refer_friend.enabled && this.account.refer_friend.eligible) items.push({
                name: this.translations.menu_item_raf,
                route: '/app/refer-friend',
                icon: 'mdi-account-plus-outline'
            });
            return items;
        }
    },

    methods: {

        setActiveRoute(route) {
            const found = this.items.find(item => item.route === route);
            if (found) this.activeRoute = found.route;
        },

        isRouteActive(route) {
            return this.activeRoute === route;
        },

        itemClicked(item) {

            if (typeof item.route === 'function') {
                item.route();
            } else {
                // Check if route is already active as this disabled error that vue router throws!
                if (this.$route.path !== item.route) {
                    this.activeRoute = item.route;
                    this.$router.push(item.route).catch(()=>{});
                }
            }
        },

        logout() {
            this.sendToUrl('/app/logout');
        },

        handleResize() {
            this.viewportWidth = window.innerWidth;
            this.viewportHeight = window.innerHeight;
        }
    },

    created() {
        this.activeRoute = this.$route.path;

        Bus.$on('navigation-drawer', (value) => {
            this.drawerModel = value;
        });
    },

    mounted() {
        window.addEventListener('resize', () => {
            this.handleResize();
        });

        Bus.$on('available-questions', (count) => {
            this.availableQuestions = count;
        });

        Bus.$on('available-surveys', (count) => {
            this.availableSurveys = count;
        });
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>

<style scoped>

.menu_item {
    height: 40px;
}

.arrowBox {
    position: absolute;
    right: 0px;

}

.arrow_box {
    position: relative;
    height: 40px;
    background-color: #EEE;
}

</style>

